import {Component, Input} from '@angular/core';
import {ExcRestService} from 'exc-rest-v2';
import {HttpClient} from '@angular/common/http';
import {ExcTranslation} from 'exc-core-v2';

@Component({
  selector: 'app-overlay-eml-viewer',
  templateUrl: './overlay-eml-viewer.component.html',
})

export class OverlayEmlViewerComponent extends ExcTranslation {

  emlData: any = null;
  isLoading = false;

  @Input() set data(value: any) {
    if (value) {
      this._data = value;
      this.loadEml(value.uid, value.jmID);
    }
  }
  get data(): any {
    return this._data;
  }
  private _data: any = {};

  constructor(
    private excRest: ExcRestService,
    private http: HttpClient
  ) {
    super();
  }

  private loadEml(uid: string, jmID: string): void {
    this.isLoading = true;
    this.http
      .get(this.excRest.computeUrl('JournalMailR_EML', {uid, jmID}), {responseType: 'text'})
      .subscribe((res: string) => {
        // console.log('JournalMailR_EML response', res);
        this.emlData = res;
        this.isLoading = false;
      }, () => {
        this.emlData = null;
        this.isLoading = false;
      });
  }
}
